import React, { Component } from 'react';
import ReactGA from 'react-ga';
import {Helmet} from 'react-helmet';
import NavTop from './NavTop/NavTop';
import 'antd/dist/antd.css';
import './App.css';
import {BackTop} from 'antd';
import LazyLoad from 'react-lazyload';
import HeaderSection from './HeaderSection/HeaderSection';
import QuoteBlock from '../common/QuoteBlock/QuoteBlock';
import WhatAreWeSection from './WhatAreWeSection/WhatAreWeSection';
import CallOutSection from './CallOutSection/CallOutSection';
import MissionStatementSection from './MissionStatementSection/MissionStatementSection';
import UpdateSection from './UpdateSection/UpdateSection';
import ContactSection from './ContactSection/ContactSection';
import MarketGrowthSection from './MarketGrowthSection/MarketGrowthSection';
import ApplicationsSection from './ApplicationsSection/ApplicationsSection';

class App extends Component {
  state = { 
    current: 'whatis',
    showVerticalDropdown: false
  };

  constructor(props){
    super(props);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    return (
      <div className="App">
        <Helmet>
            <meta charSet="utf-8" />
            <title>RealTimeTouch.com - The Missing Link in Telemedicine</title>
            <link rel="canonical" href="https://www.realtimetouch.com/" />
            <meta name="description" content="Real Time Touch: patents, researching &amp; developing new technology enabling remote video doctor-nurse-patient physical interaction at home, or on a mobile device, for medical consultation & procedures." />
         
            <meta name="robots" content="index,follow" />
            <meta name="googlebot" content="index,follow" />
            <meta name="subject" content="Telehealth, Telemedicine, mHealth, Medical Devices, eHealth" />

            <meta name="twitter:card" content="RealTimeTouch.com: the Missing Link in Telemedicine" />
            <meta name="twitter:site" content="@RealTimeTouch" />
            <meta name="twitter:creator" content="@RttCraig" />
            <meta name="twitter:url" content="https://www.realtimetouch.com/" />
            <meta name="twitter:title" content="RealTimeTouch.com: the Missing Link in Telemedicine" />
            <meta name="twitter:description" content="Real Time Touch: patents, researching &amp; developing new technology enabling remote video doctor-nurse-patient physical interaction at home, or on a mobile device" />
            <meta name="twitter:image" content="https://www.realtimetouch.com/images/general/rtt-cover-7c-lg.jpg" />
        </Helmet>
        <BackTop />
        <NavTop pageOn={this.props.pageOn} />
        <HeaderSection />
        <WhatAreWeSection />
        <LazyLoad>
          <div className="" style={{marginBottom:40}}>
            <QuoteBlock quote="0" />
          </div>
          <CallOutSection />
          <MissionStatementSection />
          <MarketGrowthSection />
          <ApplicationsSection />       
          <ContactSection />
          <UpdateSection />
          <div className="" style={{margin:40}}>
            <QuoteBlock quote="2" />
          </div>
        </LazyLoad>
       
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js